<template>
	<div class="chat-message-list" ref="messageList">
		<VueChatMessage
			v-for="(msg, index) in messages"
			:key="index"
			:message="msg"
		/>
		<VueChatMessage v-if="isLoading" :message="loadingMessage" />
	</div>
</template>

<script>
import VueChatMessage from './vue-chat-message.vue';
import { LOADING } from '@/store/modules/chat/chat-mutation-types';
import { mapGetters } from 'vuex';
import { CHAT } from '@/store/modules/chat/chat-mutation-types';
import _ from 'lodash';

export default {
	name: 'VueChatMessageList',
	components: {
		VueChatMessage
	},
	props: {
		messages: {
			type: Array,
			default: () => []
		}
	},
	mounted() {
		this.scrollToBottom();
	},
	data() {
		return {
			loadingMessage: {}
		};
	},
	computed: {
		...mapGetters('chat', [CHAT]),

		...mapGetters('chat', {
			isLoading: [LOADING]
		})
	},
	methods: {
		scrollToBottom() {
			if (_.size(this[CHAT]) > 2) {
				this.$emit('message-list-changed');
			}
		},
		generateMessage() {
			return {
				role: {
					label: 'system'
				},
				timestamp: new Date(),
				isLoading: true
			};
		}
	},
	watch: {
		messages: {
			immediate: true,
			handler() {
				this.$nextTick(() => {
					this.scrollToBottom();
				});
			}
		},
		isLoading: {
			immediate: true,
			handler(val) {
				this.loadingMessage = val ? this.generateMessage() : {};
			}
		}
	}
};
</script>

<style scoped>
.chat-message-list {
	flex-grow: 1;
	height: 400px;
	position: relative;
}
</style>
